<template>
<v-layout fill-height class="modulos">
  <v-flex xs12>
    <div class="parallax" @mousemove="parallaxEffect($event)">
      <div class="parallax_layer grass">
        <div>
          <img src="../assets/imagenes_compartidas/logo_ecopetrol.png" alt="Logo Ecopetrol">
          <h1>El ABC de las Reservas y los Recursos de Hidrocarburos</h1>
        </div>
      </div>
      <div class="parallax_layer presentacion">
        <div class="perforacion"></div>
        <router-link to="/presentacion/0" class="boton_modulo"><span class="numero_modulo">P</span>&nbsp; <span class="texto_modulo"><span class="titulo_modulo">Presentación</span></span></router-link>
      </div>
      <div class="parallax_layer modulo1">
        <div class="perforacion"></div>
        <router-link :to="conteoPags < calculateNumberOfPages(1)?'/modulos/':'/modulo1/0'" class="boton_modulo" :class="{'disabled':conteoPags < calculateNumberOfPages(1)}">
          <span class="numero_modulo">M1</span>&nbsp;<span class="texto_modulo"><span class="titulo_modulo">Módulo 1:</span> Aspectos generales y marco regulatorio <v-icon v-if="conteoPags < calculateNumberOfPages(1)">lock</v-icon></span>
        </router-link>
      </div>
      <div class="parallax_layer modulo2">
        <div class="perforacion"></div>
        <router-link :to="conteoPags < calculateNumberOfPages(2)?'/modulos/':'/modulo2/0'" class="boton_modulo" :class="{'disabled':conteoPags < calculateNumberOfPages(2)}">
          <span class="numero_modulo">M2</span>&nbsp;<span class="texto_modulo"><span class="titulo_modulo">Módulo 2:</span> Clasificación de las reservas <v-icon v-if="conteoPags < calculateNumberOfPages(2)">lock</v-icon></span>
        </router-link>
      </div>
      <div class="parallax_layer modulo3">
        <!-- <div class="perforacion"></div> -->
        <router-link :to="conteoPags < calculateNumberOfPages(3)?'/modulos/':'/modulo3/0'" class="boton_modulo" :class="{'disabled':conteoPags < calculateNumberOfPages(3)}">
          <span id="boton-modulo3" class="numero_modulo">M3</span>&nbsp;<span class="texto_modulo"><span class="titulo_modulo">Módulo 3:</span> Métodos de estimación <v-icon v-if="conteoPags < calculateNumberOfPages(3)">lock</v-icon></span>
        </router-link>
      </div>
    </div>
  </v-flex>
  
  <audio-player ref="audioPlayer" :autoplay="true" :audios="[
  'Presentacion/AUDIO 02'
  ]"></audio-player> 
</v-layout>
</template>
<script>
import scormmixins from '../js/mixins/scormmixins';
export default {
  mixins: [scormmixins],
  methods: {
    parallaxEffect(ev) {
      var box = document.getElementsByClassName('parallax')[0]
      var centerX = box.clientWidth/2
      var centerY = box.clientHeight/2
      var dx = (centerX - ev.clientX)
      var dy = (centerY - ev.clientY)

      document.getElementsByClassName('presentacion')[0].style.transform = "translateY("+ dy*0.04 +"px)"
      document.getElementsByClassName('modulo1')[0].style.transform = "translateY("+ dy*0.03 +"px)"
      document.getElementsByClassName('modulo2')[0].style.transform = "translateY("+ dy*0.02 +"px)"
      document.getElementsByClassName('modulo3')[0].style.transform = "translateY("+ dy*0.01 +"px)"
      Array.from(document.getElementsByClassName('boton_modulo')).forEach(element => {
        element.style.transform = "translateX("+ dx*0.02 +"px)"
      });
      Array.from(document.getElementsByClassName('perforacion')).forEach(element => {
        element.style.transform = "translateX("+ dx*0.02 +"px)"
      });
      document.getElementsByClassName('parallax')[0].style.transform = "translateX("+ dx*0.005 +"px)"

      
    }
  },
  updated(){
    var perforacion = document.getElementsByClassName('perforacion')[0]
    var botonm3 = document.getElementById('boton-modulo3')
    perforacion.clientHeight = botonm3.offsetTop;
    perforacion.style.top =  '0px';
    perforacion.style.left =  botonm3.offsetLeft;
  },
  methods: {
    calculateNumberOfPages(modNum) {
      return this.$store.getters.globalPage(modNum)
    }
  }
}
</script>

<style lang="scss" scoped>
$moduleHeight: 30vh;
.modulos {
  background-color: #40F2FF;
}
.parallax {
  perspective: 1px;
  height: 100vh;
  overflow-y: visible;
  position: relative;
}
.parallax_layer {
  height: $moduleHeight;
  position: absolute;
  background-size: 110% 100%;
  background-position: top center;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120vw;
  left: -10vw;
  transition: all 0.25s linear;
  @media (max-width: 600px) {
    height: 40vh;
    background-size: 200% 100%;
  }
}
.grass {
  img {
    max-height: 70px;
    padding: 5px;
    background-color: white;
    @media (max-width: 600px) {
      max-height: 50px;
    }
  }
  h1 {
    width: 100vw;
    margin: 0 10px;
    line-height: 1em;
  }
  padding-top: 5px;
  box-sizing: content-box;
  color: white;
  font-family: helveticaNeueCn;
  height: 12vh;
  z-index: 5;
  top: 0;
  right: 0;
  position: relative;
  @media (min-width: 960px) {
  background-color:#343516;
    &::after {
      z-index: -1;
      display: block;
      content: " ";
      position: absolute;
      left: 0;
      bottom: -10vh;
      height: 10vh;
      width: 100%;
      background-image: url('../assets/grass.png');
      background-repeat: no-repeat;
      background-size: 110% 100%;
      background-position: center;
    }
  }

  // Mobile
  @media (max-width: 960px) and (orientation: portrait){
    height: 30vh;
    background-image: url('../assets/modulos/grass-mobile.png');  
  }
}
.presentacion {
  top: 10vh;
  z-index: 4;
  background-image: url('../assets/ground.png');
  // Mobile
  @media (max-width: 960px) and (orientation: portrait){
    top: 28vh;
    height: 22vh;
    background-image: url('../assets/modulos/ground-mobile.png');  
  }
}
.modulo1 {
  top: 30vh;
  z-index: 3;
  background-image: url('../assets/png.png');
  // Mobile
  @media (max-width: 960px) and (orientation: portrait){
    top: 47vh;
    height: 20vh;
    background-image: url('../assets/modulos/underground-mobile.png');  
  }
}
.modulo2 {
  top: 50vh;
  z-index: 2;
  background-image: url('../assets/snow.png');// Mobile
  @media (max-width: 960px) and (orientation: portrait){
    top: 65vh;
    height: 20vh;
    background-image: url('../assets/modulos/gas-mobile.png');  
  }
}
.modulo3 {
  top: 70vh;
  z-index: 1;
  background-image: url('../assets/rock.png');
  // Mobile
  @media (max-width: 960px) and (orientation: portrait){
    top: 82vh;
    height: 20vh;
    background-image: url('../assets/modulos/petrol-mobile.png');  
  }
}

.boton_modulo {
  display: flex;
  flex-flow: row;
  align-items: center;
  transition: all 200ms;
  justify-content: center;
  text-decoration: none;
  &>*{
    transition: all 200ms;
  }
  &:hover {
    .texto_modulo::after {
      width: 100%;
    }
  }
  &.disabled:hover {
    .texto_modulo::after {
      width: 0;
    }
  }
  &.disabled{
    cursor: not-allowed;
  }
  &:active {
    &>*{
      box-shadow: 0 0 0 transparent;
    }
    transform: scale(1.0);
  }
}

.texto_modulo {
  flex: 1 1 70%;
  text-align: left;
  display: inline-block;
  color: black;
  font-family: helveticaNeueCn;
  font-weight: bold;
  padding: 5px;
  font-size: 1.2rem;
  padding-left: 2.2rem;
  position: relative;
  left: -2rem;
  width: 530px;
  max-width: calc(100vw - 70px);
  line-height: 1em;
  &::before, &::after {
    z-index: -1;
    position: absolute;
    content: " ";
    display: block;
    top: 0;
    left: 0;
    height: 100%;
    width: 0;
    background-color: white;
    transition: width 200ms;
  }
  &::before {
    background-color: #F9DB14;
    width: 100%;
  }
  @media (max-width: 960px) and (orientation: portrait) {
    font-size: 1rem;
  }
}

.numero_modulo {
  flex: 1 0;
  position: relative;
  z-index: 1;
  background-color: #004535;
  border: 2px solid white;
  border-radius: 100%;
  padding: 0.3em;
  font-size: 1.2em;
  display: inline-block;
  width: 2.3em;
  height: 2.3em;
  max-width: 2.3em;
  max-height: 2.3em;
  text-align: center;
  color: white;
}

.perforacion{
  display: block;
  height: $moduleHeight;
  width: 0.5rem;
  background-color: #444;
  border-left: 2px solid white;
  border-right: 2px solid white;
  position: absolute;
  top: 0;
  z-index: -1;
  left: calc(50% - 250px - 0.5rem);
  @media (max-width: 960px) and (orientation: portrait) {
    height: 22vh;
  }
  @media (max-width: 600px) and (orientation: portrait) {
    left: 70px;
  }
}

.titulo_modulo {
  color: #004535;
}

</style>
